// @flow

import type { Language } from '../language.js';

export const localeToPlaceLang = (lang?: string): Language => {
  switch (lang?.slice(0, 2)) {
    case 'fr':
      return 'fr';
    case 'en':
      return 'en';
    case 'de':
      return 'de';
    case 'it':
      return 'it';
    case 'es':
      return 'es';
    default:
      return 'en';
  }
};
